import React, { useEffect, useRef } from "react";

const MapQuestMap: React.FC = () => {
  const mapRef = useRef<HTMLDivElement | null>(null);
  const mapInstanceRef = useRef<any>(null);

  useEffect(() => {
    // Ensure the MapQuest library is available
    const mapQuestKey = "8nIoYUx9GyjZsdehJySzjprSvZIqgM42";

    if (!mapInstanceRef.current && window.L && window.L.mapquest) {
      window.L.mapquest.key = mapQuestKey;

      // Initialize the map
      mapInstanceRef.current = window.L.mapquest.map(mapRef.current, {
        center: [37.7749, -122.4194], // San Francisco coordinates
        layers: window.L.mapquest.tileLayer("map"),
        zoom: 12,
      });

      // Add map controls
      mapInstanceRef.current.addControl(window.L.mapquest.control());
    }
  }, []);

  return (
    <div
      id="map"
      ref={mapRef}
      style={{ width: "400px", height: "400px", border: "0", margin: "0" }}
    ></div>
  );
};

export default MapQuestMap;
